import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";

const PreviousYearMonthToDate = () => {
  const { totalRevenueMTDYearAgo, currencySymbol, totalRevenueMTDYearAgoRawDataLink } = useSelector(
    (state) => state.totalRevenue.allRevenues
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <MoneyDisplay
      value={totalRevenueMTDYearAgo}
      currency={currencySymbol}
      url={totalRevenueMTDYearAgoRawDataLink}
      size={44}
      disableAnimation={isUserQa}
    />
  );
};

export default PreviousYearMonthToDate;
